import type { MutationHookOptions } from '@apollo/client'
import {
  CreateEmployeeRelatorioUnicoFieldDocument,
  CreateEmployeeRelatorioUnicoFieldMutation,
  CreateEmployeeRelatorioUnicoFieldMutationVariables,
  GetEmployeeRelatorioUnicoFieldsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  CreateEmployeeRelatorioUnicoFieldMutation,
  CreateEmployeeRelatorioUnicoFieldMutationVariables
>

export const useCreateEmployeeRelatorioUnicoField = (options?: Options) => {
  const [createEmployeeRelatorioUnicoField, { loading }] = useMutation(
    CreateEmployeeRelatorioUnicoFieldDocument,
    {
      ...options,
      extractorFn: (data) => data.trainingsMutations.createTrainingsEmployeeRelatorioUnicoField,
    }
  )

  return {
    loading,
    create(variables: CreateEmployeeRelatorioUnicoFieldMutationVariables) {
      return createEmployeeRelatorioUnicoField({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [GetEmployeeRelatorioUnicoFieldsDocument],
      })
    },
  }
}
